import React, { forwardRef, useEffect, useRef, useState } from "react";
import SendRoundedIcon from "@mui/icons-material/SendRounded";

/**
 * Multiline input:
 * - Enter = send
 * - Shift+Enter = newline
 * Styled via ChatViewer.css (classes: .input-wrap, .chat-input, .chat-send)
 */
const ChatInput = forwardRef(function ChatInput({ onSend, placeholder }, ref) {
  const [value, setValue] = useState("");
  const localRef = useRef(null);

  useEffect(() => {
    if (!ref) return;
    if (typeof ref === "function") ref(localRef.current);
    else ref.current = localRef.current;
  }, [ref]);

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      const t = value.trim();
      if (t) {
        onSend?.(t);
        setValue("");
      }
    }
  }

  function handleSendClick() {
    const t = value.trim();
    if (!t) return;
    onSend?.(t);
    setValue("");
  }

  return (
    <div className="input-wrap">
      <textarea
        ref={localRef}
        value={value ?? ""}          // no null warnings
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={1}
        placeholder={placeholder}
        className="chat-input"
      />
      <button
        type="button"
        title="Send"
        aria-label="Send message"
        onClick={handleSendClick}
        className="chat-send"
      >
        <SendRoundedIcon fontSize="small" />
      </button>
    </div>
  );
});

export default ChatInput;
